import { useMutation } from '@tanstack/react-query';
import { createStripePortalSession } from 'src/api';
import { toast } from 'sonner';
import { ToastStyled } from 'src/components';

export const useCreateStripePortalSession = () => {
  return useMutation({
    mutationFn: createStripePortalSession,
    onError: () => {
      toast.custom((toastBlock) => (
        <ToastStyled variant='error'>
          Something went wrong. Please try again.
        </ToastStyled>
      ));
    },
  });
};
